module.exports = __webpack_public_path__ + "static/media/andreas-brucker-630339-unsplash.87c2a7ce.jpg";